import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ProductName } from 'situ-warpapi-client';
import { RecipeEventSummary, EnvironmentName } from 'situanalytics-webapi-client';
import { ProductNameService } from 'src/app/services';

@Component({
  selector: 'recipe-event-summary-card',
  templateUrl: './recipe-event-summary-card.component.html',
  styleUrls: ['./recipe-event-summary-card.component.less']
})
export class RecipeEventSummaryCardComponent {
  @Input() recipeEventSummary: RecipeEventSummary | undefined;
  @Input() searchTerm: string | undefined;
  @Input() showRenderer: boolean = false;

  productName = ProductName;
  environmentName = EnvironmentName;

  constructor(
    private productNameService: ProductNameService,
    private router: Router
  ) {}

  viewDetail(id: string) {
    this.router.navigate(['/admin/recipe-event-summary', id]);
  }

  getStatusIconAndClass(recipeEventSummary: RecipeEventSummary) {
    // in progress
    const isInProgress = !recipeEventSummary.dateCancelled && !recipeEventSummary.dateFailed
      && !recipeEventSummary.dateCompleted && !!recipeEventSummary.dateStarted;
    if (isInProgress) {
      return { icon: "pending", class: "text-info", description: "In Progress" };
    }

    // completed
    if (!!recipeEventSummary.dateCompleted) {
      return { icon: "check_circle", class: "text-success", description: "Completed" };
    }

    // failed
    if (!!recipeEventSummary.dateFailed) {
      return { icon: "error", class: "text-danger", description: "Failed" };
    }

    // cancelled
    if (!!recipeEventSummary.dateCancelled) {
      return { icon: "block", class: "text-muted", description: "Cancelled" };
    }

    // queued
    if (!!recipeEventSummary.dateQueued) {
      return { icon: "pending", class: "text-muted", description: "Queued" };
    }
  }

  getProductColour(productName: ProductName) {
    return this.productNameService.getProductNameConfiguration(productName as any)?.productColor;
  }
}